import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LorryReceiptReviewService {
  private hermesUrl = environment.hermesUrl;

  constructor(private http: HttpClient) { }

  getByAccessCode(accessCode: string): Observable<any> {
    return this.http.get<any>(
      `${this.hermesUrl}/api/v1/lorry-receipt/review/${accessCode}`
    );
  }

  verifyOtp(accessCode: string, mobileNumber: string, otp: string): Observable<any> {
    return this.http.post<any>(
      `${this.hermesUrl}/api/v1/lorry-receipt/review/${accessCode}/otp/verify`,
      {
        mobileNumber,
        type: 'SENDER_VERIFICATION',
        otp
      }
    );
  }

  resendOtp(accessCode: string): Observable<any> {
    return this.http.post<any>(
      `${this.hermesUrl}/api/v1/lorry-receipt/review/${accessCode}/otp/resend`,
      {}
    );
  }

  submitReviewAction(
    accessCode: string,
    action: 'APPROVE' | 'REJECT',
    reportingTime?: string
  ): Observable<any> {
    const body: { action: 'APPROVE' | 'REJECT'; reportingTime?: string } = { action };

    if (action === 'APPROVE' && reportingTime) {
      body.reportingTime = reportingTime;
    }

    return this.http.post<any>(
      `${this.hermesUrl}/api/v1/lorry-receipt/review/${accessCode}/action`,
      body
    );
  }
}
